/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseHoraireMatiereGridDto } from './FcbClasseHoraireMatiereGridDto';
import {
    FcbClasseHoraireMatiereGridDtoFromJSON,
    FcbClasseHoraireMatiereGridDtoFromJSONTyped,
    FcbClasseHoraireMatiereGridDtoToJSON,
} from './FcbClasseHoraireMatiereGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseHoraireMatiereGridDtoPaginatedResults
 */
export interface FcbClasseHoraireMatiereGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseHoraireMatiereGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseHoraireMatiereGridDto>}
     * @memberof FcbClasseHoraireMatiereGridDtoPaginatedResults
     */
    results?: Array<FcbClasseHoraireMatiereGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseHoraireMatiereGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseHoraireMatiereGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseHoraireMatiereGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseHoraireMatiereGridDtoPaginatedResultsFromJSON(json: any): FcbClasseHoraireMatiereGridDtoPaginatedResults {
    return FcbClasseHoraireMatiereGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseHoraireMatiereGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseHoraireMatiereGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseHoraireMatiereGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseHoraireMatiereGridDtoPaginatedResultsToJSON(value?: FcbClasseHoraireMatiereGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseHoraireMatiereGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

